import React from 'react';
import { IonSpinner } from '@ionic/react';
import styled from 'styled-components';

interface ScreenLoaderProps {
  label?: string;
  minHeight?: string;
}

const LoaderContainer = styled.div<{ $minHeight: string }>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: ${props => props.$minHeight};

  ion-spinner {
    --color: var(--ion-color-primary);
    color: var(--ion-color-primary);
    width: 36px;
    height: 36px;
  }
`;

const ScreenLoader: React.FC<ScreenLoaderProps> = ({
  label = 'Loading',
  minHeight = '55vh',
}) => (
  <LoaderContainer $minHeight={minHeight} aria-label={label} role="status">
    <IonSpinner color="primary" name="crescent" />
  </LoaderContainer>
);

export default ScreenLoader;
